import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Permission } from 'src/app/constants/permission.constant';
import { AuthService } from 'src/app/services/auth.service';
import { ProductCreateUploadComponent } from 'src/app/components/home/products/product-create-upload/product-create-upload.component';

@Component({
  selector: 'app-upload-products-action',
  templateUrl: './upload-products-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class UploadProductsActionComponent implements OnInit {
  @Output() actionComplete = new EventEmitter<void>();
  @Output() visibilityDeclared = new EventEmitter<boolean>();

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
  ) {}

  get canShow(): boolean {
    return this.authService.hasPermission(Permission.ProductsFull);
  }

  ngOnInit(): void {
    Promise.resolve().then(() => this.visibilityDeclared.emit(this.canShow));
  }

  onUpload(): void {
    const dialogRef = this.dialog.open(ProductCreateUploadComponent);
    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
        this.actionComplete.emit();
      }
    });
  }
}
